export const environment = {
  production: true,
  apiUrl: 'https://rkyh2h099h.execute-api.eu-west-1.amazonaws.com/prod/integrations',
  apiKey: 'BdaJEG4bo85cPtbYqKuMU1eXYUW2pbPU9FhMuO0T',
  stageLabel: ''
};



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/environments/environment.ts